var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDetailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0.833252H15V2.49992H6.66667V0.833252ZM6.66667 4.16658H11.6667V5.83325H6.66667V4.16658ZM6.66667 9.16658H15V10.8333H6.66667V9.16658ZM6.66667 12.4999H11.6667V14.1666H6.66667V12.4999ZM0 0.833252H5V5.83325H0V0.833252ZM1.66667 2.49992V4.16658H3.33333V2.49992H1.66667ZM0 9.16658H5V14.1666H0V9.16658ZM1.66667 10.8333V12.4999H3.33333V10.8333H1.66667Z",
    fill: "#002E6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDetailIcon);
export default __webpack_public_path__ + "static/media/ic_detail_icon.cac22ecf67bb7f3aa8c93538e3d8e224.svg";
export { ForwardRef as ReactComponent };